import XLSX from 'xlsx';


export const getValueOrDash = (val) => {
    if (val) {
        return val
    }
    else return "-"
}

export const getValueOrStr = (val) => {
    if (val) {
        return val
    }
    else return ""
}

export const exportData = (data, fileName) => {
    var tractorData = XLSX.utils.json_to_sheet(data)
    var wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, tractorData, 'data')
    XLSX.writeFile(wb, `${fileName}.xlsx`)
}